import { EChangeRelationType, EChangeType } from 'src/types'
import { ISortSelectOption } from 'src/components/filter/types/filter.types'

const changeTypesSelectValues: ISortSelectOption[] = [
  {
    label: 'all',
    value: 'all',
  },
  {
    label: 'Created',
    value: EChangeType.create,
  },
  {
    label: 'Updated',
    value: EChangeType.update,
  },
  {
    label: 'Deleted',
    value: EChangeType.delete,
  },
]

export const changeTypesSelectionOptions = {
  selectName: 'Change type',
  queryParamName: 'type',
  items: changeTypesSelectValues,
}

const changeRelationFormSelectValues: ISortSelectOption[] = [
  {
    label: 'all',
    value: 'all',
  },
  {
    label: 'Account',
    value: EChangeRelationType.account,
  },
  {
    label: 'Approval Feedback',
    value: EChangeRelationType.approval_feedback,
  },
  {
    label: 'Challenge',
    value: EChangeRelationType.challenge,
  },
  {
    label: 'Consumer Scan',
    value: EChangeRelationType.consumer_scan,
  },
  {
    label: 'Cron Job',
    value: EChangeRelationType.cron_job,
  },
  {
    label: 'Decline Reason',
    value: EChangeRelationType.decline_reason,
  },
  {
    label: 'Impact',
    value: EChangeRelationType.impact,
  },
  {
    label: 'Impact Period',
    value: EChangeRelationType.impact_period,
  },
  {
    label: 'Impact Type',
    value: EChangeRelationType.impact_type,
  },
  {
    label: 'Journey',
    value: EChangeRelationType.journey,
  },
  {
    label: 'Library Impact',
    value: EChangeRelationType.library_impact,
  },
  {
    label: 'Media',
    value: EChangeRelationType.media,
  },
  {
    label: 'Product',
    value: EChangeRelationType.product,
  },
  {
    label: 'Quantity Type',
    value: EChangeRelationType.quantity_type,
  },
  {
    label: 'Redirect URLs',
    value: EChangeRelationType.redirect_url,
  },
  {
    label: 'Reward Point',
    value: EChangeRelationType.reward_point,
  },
  {
    label: 'Scan',
    value: EChangeRelationType.scan,
  },
  {
    label: 'Step',
    value: EChangeRelationType.step,
  },
  {
    label: 'Twitter Bot',
    value: EChangeRelationType.twitter_bot,
  },
  {
    label: 'UN SDG',
    value: EChangeRelationType.un_sdg,
  },
  {
    label: 'User',
    value: EChangeRelationType.user,
  },
  {
    label: 'Vector Store',
    value: EChangeRelationType.vector_store,
  },
  {
    label: 'Web Chatbot',
    value: EChangeRelationType.web_chat_bot,
  },
  {
    label: 'White Label Partners',
    value: EChangeRelationType.white_label_partners,
  },
]

export const changeRelationFormSelectionOptions = {
  selectName: 'Form name',
  queryParamName: 'relation_form',
  items: changeRelationFormSelectValues,
}
